import React from "react";
import "./ExhibitorCard.css";
import {
  Avatar,
  Badge,
  Box,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import InteractiveAction2 from "./InteractiveAction2";

const VisitorCard = ({ item, viewMode = "grid" }) => {
  const onlineStatus = item.isOnline; // Assuming there's a flag for online status

  // Helper function to capitalize the first letter of a string
  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  const firstName = capitalizeFirstLetter(item.firstName);
  const lastName = capitalizeFirstLetter(item.lastName);

  if (viewMode === "list") {
    return (
      <Card
        elevation={0}
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          p: 2,
          border: "1px solid #eef2f6",
          borderRadius: 4,
          boxShadow: "0 4px 20px rgba(0,0,0,0.03)",
          transition: "all 0.3s ease-in-out",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 12px 24px rgba(0,0,0,0.08)",
            borderColor: "#cbd5e1",
          },
        }}
      >
        <Badge
          color="success"
          variant="dot"
          invisible={!onlineStatus}
          overlap="circular"
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Avatar
            src={item.profileImage}
            alt={`${firstName} ${lastName}`}
            sx={{
              width: 70,
              height: 70,
              backgroundColor: "#f8fafc",
              border: "3px solid #fff",
              boxShadow: "0 4px 14px rgba(0,0,0,0.06)",
            }}
          />
        </Badge>
        <Box
          sx={{
            flexGrow: 1,
            ml: { xs: 0, sm: 3 },
            mt: { xs: 2, sm: 0 },
            textAlign: { xs: "center", sm: "left" },
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: 800, color: "#1e293b", fontSize: "1.1rem" }}
          >
            {firstName} {lastName}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#64748b",
              fontWeight: 600,
              mt: 1,
              backgroundColor: "#f8fafc",
              border: "1px solid #e2e8f0",
              display: "inline-block",
              px: 1.5,
              py: 0.5,
              borderRadius: "16px",
            }}
          >
            {item.designation ? item.designation : "Visitor"}
          </Typography>
        </Box>
        <Box sx={{ mt: { xs: 2, sm: 0 } }}>
          <InteractiveAction2 item={item} />
        </Box>
      </Card>
    );
  }

  return (
    <Card
      elevation={0}
      sx={{
        maxWidth: 300,
        height: 280,
        border: "1px solid #eef2f6",
        borderRadius: 4,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        transition: "all 0.3s ease-in-out",
        boxShadow: "0 4px 20px rgba(0,0,0,0.03)",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 12px 24px rgba(0,0,0,0.08)",
          borderColor: "#cbd5e1",
        },
      }}
    >
      <CardContent sx={{ textAlign: "center", flexGrow: 1 }}>
        <Badge
          color="success"
          variant="dot"
          invisible={!onlineStatus}
          overlap="circular"
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Avatar
            src={item.profileImage}
            alt={`${firstName} ${lastName}`}
            sx={{
              width: 90,
              height: 90,
              margin: "auto",
              backgroundColor: "#f8fafc",
              border: "3px solid #fff",
              boxShadow: "0 4px 14px rgba(0,0,0,0.06)",
              transition: "transform 0.3s ease",
              "&:hover": { transform: "scale(1.05)" },
            }}
          />
        </Badge>
        <Box sx={{ mt: 2 }}>
          <Box height="48px">
            <Typography
              variant="h6"
              sx={{
                fontWeight: 800,
                color: "#1e293b",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 2,
                lineHeight: "1.2em",
                maxHeight: "2.4em",
                fontSize: { xs: "1rem", sm: "1.1rem", md: "1.2rem" },
              }}
            >
              {firstName} {lastName}
            </Typography>
          </Box>
          <Typography
            variant="body2"
            sx={{
              color: "#64748b",
              fontWeight: 600,
              mt: 1,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              backgroundColor: "#f8fafc",
              border: "1px solid #e2e8f0",
              display: "inline-block",
              px: 1.5,
              py: 0.5,
              borderRadius: "16px",
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: "#f1f5f9",
                color: "#0f172a",
              },
            }}
          >
            {item.designation ? item.designation : "Visitor"}
          </Typography>
        </Box>
        <Box mt={2}></Box>
        <InteractiveAction2 item={item} />
      </CardContent>
    </Card>
  );
};

export default VisitorCard;
